<!-- @format -->

<div class="order-summary-card">
  @if (gift?.email && gift?.message && !confirmationPage) {
    <div
      class="gift-order section">
      <div class="gift-head-container">
        <img
          [src]="giftIcon"
          class="gift-icon"
          alt="Gift package icon with an email symbol, representing gift shipment notification" />
        <p class="heading gift-heading">Gift Order</p>
      </div>
      <p>
        When this order ships, we'll send an email to
        <span class="bold">{{ gift?.email }}</span> with a tracking link and your gift message:
        <span class="italic">{{ gift?.message }}</span>
      </p>
    </div>
  }
  @if (contact?.firstName && contact?.lastName) {
    <div
      class="contact-info section">
      <p
        [ngClass]="{ 'hmf-pt-0': gift?.email && !confirmationPage }"
        class="heading your-contact-info">
        Your Contact Info
      </p>
      @if (!confirmationPage || (!displayNameInBillingAddress && !isPaypalReviewPage)) {
        <p
          class="hmf-text-transform-capitalize"
          >
          {{ contact?.firstName }} {{ contact?.lastName }}
        </p>
      }
      <p>{{ contact?.email }}</p>
      <p>{{ $safeNavigationMigration(contact?.phone) | phoneNumber }}</p>
    </div>
  }
  @if (additional?.firstName && additional?.lastName) {
    <div
      class="additional-pickup-person section">
      <p class="heading additional-person-header">Additional Pickup Person</p>
      <p>{{ additional?.firstName }} {{ additional?.lastName }}</p>
      <p>{{ additional?.email }}</p>
      @if (confirmationPage) {
        <p
          class="email-text">
          When the order is ready for pickup, we'll send an email to you and
          {{ additional?.email }}.
        </p>
      }
    </div>
  }
  @if (address !== undefined) {
    <div
      class="billing-address section">
      <p class="heading billing-address-header">Billing Address</p>
      @if (confirmationPage || (isPaypalReviewPage && displayNameInBillingAddress)) {
        <p
          class="hmf-text-transform-capitalize">
          {{ contact?.firstName }} {{ contact?.lastName }}
        </p>
      }
      @if (confirmationPage) {
        <p
          class="billing-address-text">
          {{ address?.address }} {{ address?.city }}, {{ address?.state }} {{ address?.zipcode }}
        </p>
      }
      @if (!confirmationPage) {
        <p
          class="billing-address-text">
          {{ address?.address1 }} {{ address?.city }}, {{ address?.state }}
          {{ address?.postalCode }}
        </p>
      }
    </div>
  }
  @if (payments.length >= 1) {
    <div
      class="payment section">
      <p class="heading payment-header hmf-pb-xxxs">Payment</p>
      @for (payment of payments; track trackByFn($index, payment)) {
        <div
          [ngClass]="{ 'paypal-formatting': payment.icon === 'paypal' }"
          class="payment-method"
          >
          <div
				[ngClass]="{
					giftCard: payment.icon === undefined
				}"
            class="method-icon">
            @if (payment.icon === 'paypal') {
              <img
                src="assets/image/paypal-myaccount.png"
                alt="Paypal" />
            }
            @if (payment.icon !== 'paypal' && payment.icon !== undefined) {
              <homefield-icon
                width="51px"
                height="34px"
              [name]="payment.icon"></homefield-icon>
            }
            @if (payment.type.toUpperCase() === 'GIFT CARD') {
              <span>GIFT CARD</span>
            }
          </div>
          <div class="method-details">
            <p>
              <span class="bold">{{ payment.title }}</span>
            </p>
            <p>(${{ payment.amount }})</p>
          </div>
        </div>
      }
    </div>
  }
</div>
